import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import LaMaison from './pages/LaMaison';
import Collection from './pages/Collection';
import ProductDetail from './pages/ProductDetail';
import NotreVision from './pages/NotreVision';
import Transparence from './pages/Transparence';
import Contact from './pages/Contact';
import Legal from './pages/Legal';
import Login from './pages/Login';

function AppContent() {
  const location = useLocation();
  const { user, loading } = useAuth();
  const isProduct = location.pathname.startsWith('/collection/') && location.pathname !== '/collection';

  // Écran de chargement pendant la vérification de session
  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="w-8 h-8 border border-white/20 border-t-white/60 rounded-full animate-spin" />
      </div>
    );
  }

  // Pas connecté → login wall
  if (!user) {
    return <Login />;
  }

  return (
    <>
      <Navbar />
      <main className="min-h-screen">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/la-maison" element={<LaMaison />} />
          <Route path="/collection" element={<Collection />} />
          <Route path="/collection/:id" element={<ProductDetail />} />
          <Route path="/notre-vision" element={<NotreVision />} />
          <Route path="/transparence" element={<Transparence />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mentions-legales" element={<Legal />} />
        </Routes>
      </main>
      {!isProduct && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
